import { Card } from "@components/ui-kit";
import { Trans, t } from "@lingui/macro";
import { ButtonBudgetSettings } from "./ButtonBudgetSettings";
import emptyBudgetItemsImageSrc from "./img/emptyBudgetItems.png";

export const CardEmpty = () => (
  <Card sectioned>
    <div className="flex items-center my-12 mx-10">
      <div className="mr-20">
        <img src={emptyBudgetItemsImageSrc} alt={t`empty budget items`} />
      </div>

      <div className="w-9/12">
        <h1 className="text-3xl font-semibold mb-5">
          <Trans>
            Set-up your budgets to see progress and balance of your project.
          </Trans>
        </h1>

        <p className="text-darkGray">
          <Trans>
            You can assign to project "final" proposal or you can create a new
            budget.
          </Trans>
        </p>
      </div>

      <div className="w-3/12 text-right">
        <ButtonBudgetSettings />
      </div>
    </div>
  </Card>
);
